require('./index.less');

var SideHeader = require('../sidePanelHeader.js');



module.exports = SideHeader.extend({

    template: require('./headerLeft.hbs'),
    onRender: Backbone.View.prototype.unwrap,

    serializeData: function() {

        var vChannel = this.options.vChannel;

        return {
             showIndexes: vChannel.request('includeIndexesModule'),
             showThumbnails: this._showThumbnails(),
             includeFindAndRedactModule: vChannel.request('includeFindAndRedactModule')
        };

    },

    ui: {
        thumbsBtn: '#toggleThumbs'
    },

    /* Thumbnails should never be visible in PDF mode */
    toggleHeaderViewModeState: function() {

        this.ui.thumbsBtn.toggleClass( 'hide', !this._showThumbnails() );

    },

    _showThumbnails: function() {
        return this.options.vChannel.request('allowThumbnails');
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/layout/header/headerLeft/headerLeft.js
 ** module id = 730
 ** module chunks = 0
 **/